import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipComponent } from '../tooltip/tooltip.component';
import { TranslatePipe } from '../../directives/TranslatePipe';

export interface TreeNode {
  key: string;
  value: string;
  state: 'selected' | 'partial-select' | 'not-selected';
  children?: TreeNode[];
  expanded?: boolean;
}

@Component({
  selector: 'app-tree-node',
  standalone: true,
  imports: [CommonModule, TreeNodeComponent, TooltipComponent, TranslatePipe],
  templateUrl: './tree-node.component.html',
  host: { class: 'block' }
})
export class TreeNodeComponent {
  @Input() node!: TreeNode;
  @Output() selectionChange = new EventEmitter<void>();

  toggleExpand() {
    if (this.node.children?.length) {
      this.node.expanded = !this.node.expanded;
    }
  }

  toggleCheckbox(event: Event) {
    event.stopPropagation();

    const newSelected = this.node.state !== 'selected';
    this.setNodeAndDescendants(this.node, newSelected);
    this.updateAncestors();
    this.selectionChange.emit();
  }

  getTooltipText(node: TreeNode) {
    let text = `${node?.value} Permission`;
    switch (node?.state) {
      case 'selected':
        return text + ' Fully Granted';
      case 'partial-select':
        return text + ' Restricted';
      case 'not-selected':
        return text + ' Revoked';
    }
  }

  selectNode() {
    // Clic sur le texte 
    this.toggleCheckbox(new Event('click'));
  }

  onChildChange() {
    this.updateNodeState(this.node);
    this.updateAncestors();
    this.selectionChange.emit();
  }

  private setNodeAndDescendants(node: TreeNode, selected: boolean) {
    node.state = selected ? 'selected' : 'not-selected';
    node.children?.forEach(child => this.setNodeAndDescendants(child, selected));
  }

  private updateNodeState(node: TreeNode) {
    if (!node.children?.length) return;

    const childStates = node.children.map(c => c.state);
    const allSelected = childStates.every(s => s === 'selected');
    const noneSelected = childStates.every(s => s === 'not-selected');

    if (allSelected) {
      node.state = 'selected';
    } else if (noneSelected) {
      node.state = 'not-selected';
    } else {
      node.state = 'partial-select';
    }
  }

  private updateAncestors() {
    this.updateNodeState(this.node);
  }

  protected get nodeValue(): string {
    let finalValue = this.node?.value ? this.node?.value : "";
    finalValue = finalValue.split('.').join('_');
    return finalValue;
  }
}
